import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import styles from './styles.scss';

export default class PaginationPage extends React.PureComponent {
  static contextTypes = {
    orderId: PropTypes.string,
  };

  componentWillReceiveProps(nextProps) {
    const { done, spread, track } = nextProps;
    const currentDone = this.props.done;

    // Rather have this in a saga
    if (!currentDone && done && spread) {
      track('spread_ready', {
        spread_id: spread.get('id'),
      });
    } else if (currentDone && !done) {
      track('spread_unready', {
        spread_id: spread.get('id'),
      });
    }
  }

  render() {
    const { className = '', spread, active, hideLabel, partial, seen, done, setActiveSpread, children } = this.props;
    const id = spread ? `${spread.get('id')}` : null;

    const classes = cx(className, styles.spread, {
      [styles.partial]: partial,
      [styles.seen]: seen,
      [styles.done]: done,
      [styles.active]: active,
    });

    return (
      <a onClick={setActiveSpread} data-id={id} className={classes}>
        {children ? children : <span />}
        {spread && !hideLabel ? <div className={styles.label}>{spread.get('label')}</div> : null}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/pagination-page/index.js